import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { initAnalytics, trackEvent } from './services/analytics';
import { ANALYTICS_EVENTS } from './services/analytics/events';

void initAnalytics().then(() => {
  trackEvent(ANALYTICS_EVENTS.APP_SESSION_START);
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing root element');
}

createRoot(rootElement).render(<App />);
